import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { GetServerSideProps, GetServerSidePropsContext } from 'next'

import { first } from '@/utils/common'
import api, { FaqItem } from '@/service'

import Meta from '@/components/Meta'
import Hero from '@/components/faq/Hero'
import ContactSection from '@/components/sections/ContactSection'
import Partners from '@/components/sections/Partners'
import Navipay from '@/components/parking/Navipay'
import SearchList from '@/components/faq/SearchList'
import { useMarket } from '@/utils/multi-markets/context'
import { loadTranslationsWithMarket } from '@/utils/loadTranslations'
import DefaultLayout from '@/components/layouts/Default'

export const getServerSideProps = (context: GetServerSidePropsContext) => {
  return loadTranslationsWithMarket(context, {
    cache: 'no-cache',
    namespaces: ['faq', 'common']
  })
}

function FaqSearch() {
  const { t } = useTranslation('faq')
  const [searchResults, setSearchResults] = useState<FaqItem[]>()
  const [showResults, setShowResults] = useState(false)
  const [loading, setLoading] = useState(false)
  const router = useRouter()
  const { locale } = useMarket()

  const search = () => {
    setLoading(true)
    const payload = {
      query: first(router.query.search),
      lang: locale
    }

    api.faqInternal
      .all(payload)
      .then(response => {
        setSearchResults(response.data.items)
        setShowResults(true)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (router.isReady) {
      router.query.search ? search() : router.push({ pathname: '/faq' })
    }
  }, [router.query, router.isReady])

  return (
    <DefaultLayout>
      <Meta title={t('meta.title')} />
      <Hero loading={loading} />
      {showResults && searchResults && <SearchList results={searchResults} />}
      <Navipay />
      <ContactSection />
      <Partners />
    </DefaultLayout>
  )
}

export default FaqSearch
